import React from 'react';
import { usePushNotifications } from '../hooks/usePushNotifications';

const PushPermissionPrompt = () => {
  const { permission, requestPermission, isSupported } = usePushNotifications();

  if (!isSupported) return null;
  if (permission === 'granted') return null;
  if (permission === 'denied') {
    return (
      <div style={styles.denied}>
        Notificações bloqueadas. Ative nas configurações do navegador.
      </div>
    );
  }

  return (
    <div style={styles.prompt}>
      <p>🔔 Receba notificações de novas mensagens mesmo com o app fechado!</p>
      <button onClick={requestPermission} style={styles.button}>
        Ativar notificações
      </button>
    </div>
  );
};

const styles = {
  prompt: {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    backgroundColor: 'white',
    padding: '16px',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    zIndex: 1000,
    border: '1px solid #e2e8f0',
    maxWidth: '300px'
  },
  button: {
    backgroundColor: '#1A3B7D',
    color: 'white',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '4px',
    cursor: 'pointer',
    width: '100%',
    marginTop: '8px'
  },
  denied: {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    backgroundColor: '#fee2e2',
    color: '#dc2626',
    padding: '12px',
    borderRadius: '4px',
    fontSize: '14px'
  }
};

export default PushPermissionPrompt;